import { api, helpers } from "../../../utils";
const { stored } = api.net.config;
const cafe = {
    sms: {
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;

const forgot = async ({ dispatch, commit }, payload) => {
    const p = new Promise(async (resolve) => {
        if (!payload || !payload.Email) return resolve({ error: cafe.sms.invalid_inputs });
        const { Email } = payload;
        let filter = { Email };
        hlog.start("authen.password.forgot.check", "start", filter);
        const res_check = await api.net.data.warehouse.load.topOne({ storeName: stored.dw.CheckNewMember, filter });
        hlog.end("authen.password.forgot.check", "end", res_check);
        let isNotValid = !res_check || !res_check.isSuccess;
        if (isNotValid) return resolve({ error: res_check.error });
        const { CountEmail, MemberName, Gender } = res_check.data;
        let error = `Xin lỗi, chúng tôi không tìm thấy email "${Email}" trong hệ thống! Bạn hãy đăng ký mới với email này!`;
        if (!CountEmail) return resolve({ error });
        let IP = await dispatch("loadIP", null, { root: true });
        filter = { Email, MemberName, Gender, IP };
        hlog.start("authen.password.forgot.send.code", "start", filter);
        let res_pwr = await api.node.origin.password.forgot(filter);
        hlog.end("authen.password.forgot.send.code", "end", res_pwr);
        isNotValid = !res_pwr || !res_pwr.is_success;
        if (isNotValid) return resolve({ error: res_pwr.error });
        let data = { status: "reseting", Email, MemberName, Gender };
        commit({ type: "loadData", data });
        resolve({ isSuccess: true, data });
    });

    return p;
};

const reset = ({ dispatch, commit }, payload) => {
    const p = new Promise(async (resolve) => {
        if (!payload || !payload.ResetCode) return resolve({ error: cafe.sms.invalid_inputs });
        const { Email, MemberName, Gender, ResetCode, Password } = payload;
        let IP = await dispatch("loadIP", null, { root: true });
        let filter = { Email, MemberName, Gender, ResetCode, Password, IP };
        hlog.start("authen.password.reset", "start", filter);
        const res = await api.node.origin.password.reset(filter);
        hlog.end("authen.password.reset", "end", res);
        let isNotValid = !res || !res.is_success;
        if (isNotValid) return resolve({ error: res.error });
        let state = { status: "done" };
        commit({ type: "loadData", data: state });

        resolve(res);
    });

    return p;
};

const loadPasswordReset = ({ rootState, state, commit }) => {
    const p = new Promise(async (resolve) => {
        let { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        const { SessionID } = headers;
        let filter = { SessionID };
        hlog.start("authen.password.load", "start", filter);
        state.status = null;
        const res = await api.net.data.bot.load.list({ storeName: stored.GetPasswordReset, filter });
        hlog.end("authen.password.end", "end", res);
        let isNotValid = !res || !res.isSuccess || !Array.isArray(res.data) || !res.data.length;
        if (isNotValid) return resolve({ data: state.status });
        state.status = "reseting";
        const { Email, MemberName, Gender } = res.data[0];
        let data = { Email, MemberName, Gender, status: state.status };
        commit({ type: "loadData", data });
        resolve({ data });
    });

    return p;
};

export default {
    forgot,
    reset,
    loadPasswordReset,
};



// WEBPACK FOOTER //
// src/store/authen/password/actions.js